
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ar/[treatment]",
      function () {
        return require("private-next-pages/ar/[treatment].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ar/[treatment]"])
      });
    }
  